import { FintrafficIntlProvider } from './FintrafficIntlProvider';
export default FintrafficIntlProvider;
